import { useEffect, useState } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import EmailStep from "./EmailStep";
import VerifyStep from "./VerifyStep";
import CreatePasswordStep from "./CreatePasswordStep";
import AuthPasswordLayout, {
  Container,
  Subtitle,
  Title,
} from "../../modules/Auth/components/AuthPasswordLayout";
import { denyFirstAccess } from "./firstAccessCrud";
import { FIRST_ACCESS_ROUTES } from "./routes";
import useFirstAccessFlow from "./hooks/useFirstAccessFlow";

function DenyStep() {
  const location = useLocation();
  const [message, setMessage] = useState("Registrando sua solicitação...");
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get("email");

    if (!email) {
      setMessage("E-mail não informado.");
      setIsError(true);
      return;
    }

    denyFirstAccess(email)
      .then(() => {
        setMessage(
          "Recebemos sua solicitação. Se você não reconhece este acesso, nenhuma ação adicional é necessária."
        );
      })
      .catch(() => {
        setMessage(
          "Não foi possível registrar sua solicitação. Tente novamente."
        );
        setIsError(true);
      });
  }, [location.search]);

  return (
    <AuthPasswordLayout variant="none">
      <Container>
        <Title>Não fui eu</Title>
        <Subtitle style={{ color: isError ? "#e53935" : undefined }}>
          {message}
        </Subtitle>
      </Container>
    </AuthPasswordLayout>
  );
}

export default function FirstAccess() {
  const location = useLocation<{ email?: string }>();
  const fragmentParams = new URLSearchParams(location.hash.replace(/^#/, ""));
  const queryParams = new URLSearchParams(location.search);
  const email =
    location.state?.email ||
    fragmentParams.get("email") ||
    queryParams.get("email") ||
    undefined;
  const { isFirstAccessFlowEnabled, flagResolved } = useFirstAccessFlow(email);

  if (!flagResolved) {
    return <LayoutSplashScreen />;
  }

  if (!isFirstAccessFlowEnabled) {
    return <Redirect to="/auth/login" />;
  }

  return (
    <Switch>
      <Route exact path={FIRST_ACCESS_ROUTES.DENY} component={DenyStep} />
      <Route
        exact
        path={FIRST_ACCESS_ROUTES.CREATE_PASSWORD}
        component={CreatePasswordStep}
      />
      <Route
        exact
        path={FIRST_ACCESS_ROUTES.VERIFICATION}
        component={VerifyStep}
      />
      <Route path={FIRST_ACCESS_ROUTES.BASE} component={EmailStep} />
    </Switch>
  );
}
